import { authAxios, publicAxios ,authAxiosForUpdatePassword } from "../config";
import { ApiKey } from "../endpoints";
import { RoleId } from "../../app/Enums/RoleId";
import axios from "axios";
import { API_URL } from "../../Apis_chatbot/apis";
import { _baseURL } from "../config";
import { toast } from "react-toastify";

export const userLoginReq = async ({ Email, password }) => {
  try {
    const body = { Email, Password: password };
    
    console.log("Before login - Cookies:", document.cookie);
    
    const res = await publicAxios.post(`${ApiKey.loginKey}`, body);
    
    console.log("After login - Cookies:", document.cookie);
    console.log("Login response headers:", res.headers);
    console.log("Set-Cookie header:", res.headers['set-cookie']);
    
    const result = res?.data?.result_value?.roleId;
    if (result === RoleId.User) {
      toast.error("You are not authorized to access this portal");
      return;
    }
    
    const _data = {
      token: res?.data?.result_value?.token || "",
      expiresAt: res?.data?.result_value?.expiresAt || "",
      roleId: res?.data?.result_value?.roleId || "",
      username: res?.data?.result_value?.username || "",
      roleName: res?.data?.result_value?.roleName || "",
      userId: res?.data?.result_value?.userId || 0,
      // refreshToken: res?.data?.result_value?.refreshToken || "",
    };

    localStorage.setItem("token", _data.token);
    localStorage.setItem("tokenExpire", _data.expiresAt);
    localStorage.setItem("RoleId", _data.roleId);
    localStorage.setItem("username", _data.username);
    localStorage.setItem("roleName", _data.roleName);
    localStorage.setItem("UserId", _data.userId);
    
    // Also store refresh token in localStorage as backup
    localStorage.setItem("refreshToken", _data.refreshToken);
    
    return { error: false, data: res, message: "", errorMsg: "" };
    
  } catch (err) {
    console.error("Login error:", err);
    let error = err.response?.data;
    console.error(error);
  }
};

const VerifyOtp = async (formData) => {
  try {
    const response = await publicAxios.post(`${ApiKey.verifyOTP}`, formData);
    return response; // return response.data instead of full response
  } catch (error) {
    console.error("login failed:", error);
    throw error;
  }
};

const GetOtpOnEmail = async (formData) => {
  try {
    const response = await publicAxios.post(`${ApiKey.getOtpEmail}`, formData);
    return response; // return response.data instead of full response
  } catch (error) {
    console.error("login failed:", error);
    throw error;
  }
};

const UpdatePassword = async (formData) => {
  try {
    const response = await authAxiosForUpdatePassword.post(`${ApiKey.updatePassword}`, formData);
    return response; // return response.data instead of full response
  } catch (error) {
    console.error("Failed to update password:", error);
    throw error;
  }
};

const ChangePasswordByOldPassword = async (formData) => {
  try {
    const response = await authAxios.post(`${ApiKey.changePasswordByOldPassword}`, formData);
    return response; // return response.data instead of full response
  } catch (error) {
    console.error("Failed to change password:", error);
    throw error;
  }
};

export { UpdatePassword, VerifyOtp, GetOtpOnEmail ,ChangePasswordByOldPassword};
